import {
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { ChevronLeftOutlined as ArrowLeftIcon } from "@mui/icons-material";
import Button from "../../theme/components/Button.jsx";
import PropTypes from "prop-types";

export default function ClaimPreCheckModal({ open, onClose }) {
  const navigate = useNavigate();

  const handleGoToOverview = () => {
    // First close the dialog (which also clears URL params via parent),
    // then navigate to the Schaden overview.
    onClose();
    navigate("/schaeden");
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Schaden gemeldet</DialogTitle>
      <DialogContent dividers>
        <Typography variant="paragraph">
          Vielen Dank für die Meldung des Schadens. Dieser befindet sich nun in
          Prüfung.
        </Typography>
        <Typography variant="body1">
          Angaben zu den Schadenkosten können nachträglich über den Reiter
          Kostenpositionen auf der Schadenseite getätigt werden.
        </Typography>
      </DialogContent>
      <DialogActions sx={{ justifyContent: "space-between" }}>
        <Button
          variant="neutral"
          startIcon={<ArrowLeftIcon />}
          onClick={handleGoToOverview}
        >
          Übersicht
        </Button>
        <Button onClick={onClose} variant="primary">
          Zur Schadenseite
        </Button>
      </DialogActions>
    </Dialog>
  );
}

ClaimPreCheckModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};
